<template>
  <div class="container d-panel">
    <div class="d-panel-header">
        <template v-if="$slots.header">
           <slot name="header"></slot>
        </template>
        <template v-else>
            
            <div class="d-panel-header-title">
                <BaseIcon class="d-panel-header-title-icon" :icon="icon" :size="16" />
                {{title}}
            </div>
            <div class="d-panel-header-tabs"
                v-if="tabs && tabs.length > 0"
            >
                <template v-for="tab in tabs">
                    <div class="d-panel-header-tab-item"
                        :class="{
                           'd-panel-header-tab-item-active': tab.key == currentTab
                        }"
                        :key="tab.key"
                        @click="handleClickTab(tab.key)"
                        >
                        
                        {{tab.title}}
                        <span 
                            class="count"
                            :class="tab.count?'':'zero-count'"
                            v-if="tab.count !== undefined">{{tab.count}}</span>
                    </div>
                </template>
            </div>
            <div class="d-panel-header-extra" v-if="$slots.extra">
                <slot name="extra"></slot>
            </div>
        </template>
    </div>
    <div class="d-panel-content">
        <slot></slot>
    </div>
  </div>
</template>

<script>
import responsibleMixin from '@/mixins/responsable';
export default {
    mixins:[responsibleMixin],
    data(){
        return {
            currentTab:this.defaultTab || ''
        }  
    },
    props:{
        icon:{
            type:String,
            default:'md-apps'
        },
        title:{
            type:String,
            default:''
        },
        tabs:{
            type:Array,
            default:()=>([])
        },
        defaultTab:{
            type:String,
            default:''
        }
    },
    mounted(){
        if(this.tabs && this.tabs.length > 0){
            this.currentTab = this.defaultTab || this.tabs[0].key;
        }
    },
    watch: {
        defaultTab(v) {
            if (v != null && v !== '' && v !== this.currentTab) {
                this.currentTab = v;
            }
        },
    },
    methods:{
        handleClickTab(key){
            this.currentTab = key;
            this.$emit('on-tab-change', key);
        },
        /** 外部强制切换 */
        setTab(key) {
            if (!key) return;
            this.currentTab = key;
        },
    }
}
</script>

<style lang="less">
.d-panel{
    .d-panel-header{
        display: flex;
        align-items: center;
        justify-content: space-between;
        width:100%;
        height:30px;
        background:var(--bg1);
        color:var(--text1);
        border-bottom:1px solid var(--border);
        padding:0 5px;
        border-top-left-radius:5px;
        border-top-right-radius:5px;

        .d-panel-header-title{
            display: flex;
            align-items: center;
            .d-panel-header-title-icon{
                margin-right:5px;
            }
        }

        .d-panel-header-tabs{
            display: flex;
            flex-grow:1;
            justify-content: flex-end;
            margin-right:10px;
            align-items: center;
            
            .d-panel-header-tab-item{
                color:var(--subtext2);
                margin-left:10px;
                min-width:50px;
                text-align: center;
                cursor:pointer;
                &:hover{
                    color:var(--primary);
                }
                .count{
                    padding:0 5px;
                    font-size:12px;
                    border-radius:5px;
                    background:var(--bg1);
                    color:var(--text1);
                }
                .zero-count{
                    background:var(--border);
                    color:var(--subtext2);
                }
            }

            .d-panel-header-tab-item-active{
                    color:var(--primary);
                    font-weight: bold;
                    .count{
                        background:var(--primary);
                        color:var(--hover-text);
                    }
            }
        }
        .d-panel-header-extra{
            flex-shrink: 0;
            display: flex;
            align-items: center;
            margin-left: 4px;
        }
    }

    .d-panel-content{
        width:100%;
        height:calc(100% - 30px);
        position: relative;
    }
}


</style>